export const getMaxDate = (date1: Date | undefined, date2: Date | undefined): Date | undefined => {
  if (!date1 || !date2) return date1 || date2;

  return new Date(Math.max(date1.valueOf(), date2.valueOf()));
};
